import React, { useState, useContext } from 'react';
import "../css/SignIn.css";
import logo from "../img/logo.png";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoginContext } from '../context/LoginContext';

export default function SignIn() {
  const { setUserLogin } = useContext(LoginContext);
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const notifyA = (msg) => toast.error(msg);
  const notifyB = (msg) => toast.success(msg);

  const postData = () => {
    setLoading(true);

    const cleanPhone = phone.replace(/\D/g, '');
    if (cleanPhone.length !== 10) {
      setLoading(false);
      notifyA("Please enter a valid 10-digit phone number");
      return;
    }

    if (!password) {
      setLoading(false);
      notifyA("Please enter your password");
      return;
    }

    fetch("/signin", {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        phone: cleanPhone,
        password: password
      })
    })
    .then(async (res) => {
      if (!res.ok) {
        if (res.status === 401 || res.status === 422) {
          const errBody = await res.json().catch(() => ({}));
          setLoading(false);
          notifyA(errBody.error || 'Invalid Phone number or Password');
          return null;
        }
        try {
          const errBody = await res.json();
          setLoading(false);
          notifyA(errBody.error || 'Sign in failed');
        } catch (e) {
          setLoading(false);
          notifyA('Sign in failed');
        }
        return null;
      }
      return res.json();
    })
    .then(data => {
      if (!data) return;
      setLoading(false);
      if (data.error) {
        notifyA(data.error);
      } else {
        notifyB("Signed In Successfully");
        localStorage.setItem("jwt", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        setUserLogin(true);
        try { window.dispatchEvent(new CustomEvent('user-changed')); } catch (e) {}
        navigate("/profile");
      }
    })
    .catch(err => {
      setLoading(false);
      notifyA('Network error. Please try again.');
      console.error(err);
    });
  };

  return (
    <div className='signIn'>
      <div>
        <div className="loginForm">
          <img className='signUpLogo' src={logo} alt="Logo" />
          <h1 style={{color: "white"}} className='appNameLogin'>TheMediFile</h1>
          <p className='pointLine' style={{ marginTop: "-22px" }}>Store your medical details on internet</p>
          <div style={{ backgroundColor: "black", borderRadius: "15px", padding: "15px" }} className="backForm">
            <div>
              <input
                style={{border: "1px solid #d39797", width: "100%"}}
                className='mainInputsLogin'
                type="tel"
                name="phone"
                id='phone'
                value={phone}
                placeholder='Phone Number (10 digits)'
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                  setPhone(digits);
                }}
                maxLength={10}
              />
            </div>
            <div>
              <input
                style={{border: "1px solid #d39797", width: "100%"}}
                type="password"
                name="password"
                id='password'
                placeholder='Password'
                value={password}
                onChange={(e) => setPassword(e.target.value.slice(0, 120))}
                className='mainInputsLogin'
                maxLength={120}
              />
            </div>
            <button type="button" id='login-btn' onClick={postData} disabled={loading}>
              {loading ? <span className="btn-spinner" /> : 'Login'}
            </button>
          </div>
          <hr />
          <p style={{ backgroundColor: "black", color: "white", display: "inline-block" }}>Don't have an account ?</p>
          <Link to="/signup">
            <span style={{ color: 'yellow', backgroundColor: "black", cursor: 'pointer' }}> Sign Up</span>
          </Link>
          <br />
          <div style={{ backgroundColor: "black", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "10px", width: "100%" }}>
            <p>a <b>Subodh Sathe</b> creation</p>
            <b>TheMediFile &copy; 2026</b>
            <a href="/support" target="_blank" rel="noopener noreferrer" style={{ color: 'yellow', backgroundColor: "black", textDecoration: "underline", marginTop: 6, display: 'inline-block' }}>Contact Us</a>
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'yellow', backgroundColor: "black", textDecoration: "underline", marginTop: 6, display: 'inline-block' }}>Privacy Policy</a>
            <a href="/csae-standards" target="_blank" rel="noopener noreferrer" style={{ color: 'yellow', backgroundColor: "black", textDecoration: "underline", marginTop: 6, display: 'inline-block', marginBottom: "15px" }}>CSAE Standards</a>
          </div>
        </div>
      </div>
    </div>
  );
}
